import { IncidentStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const incidentStatusColorName = (severity: IncidentStatus) => {
  switch (severity) {
    case IncidentStatus.AwaitingReview:
      return ['yellow', 'Awaiting review'];
    case IncidentStatus.Reviewed:
      return ['green', 'Reviewed'];
  }
};

interface Props extends ChakraV3.TagRootProps {
  status: IncidentStatus;
}

export const IncidentStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const [color, name] = incidentStatusColorName(status);

  return (
    <ChakraV3.TagRoot colorPalette={color} {...rest}>
      <ChakraV3.TagLabel>{name}</ChakraV3.TagLabel>
    </ChakraV3.TagRoot>
  );
};
